import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Section from '../components/Section';
import OurClasses from "./Classes/OurClasses";
import TimesFees from "./Classes/TimesFees";
import TeacherCards from "./Classes/TeacherCards";




const Classes = () => {

  return (

    <>

      <Navbar/>
        
          
      {/* Our Classes Section */}
      <Section>
        <OurClasses/>
      </Section>

      {/* Class Times and Fees Section */}
      <Section>
        <TimesFees/>
      </Section>


      <Footer/>
    
    </>

  );

}

export default Classes;